module.exports = __webpack_public_path__ + "wordo.png?a3e25133f97dd2d540af14bc3b6cc241";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/wordo.png
// module id = 216
// module chunks = 0